<template>
    <h5 class="right" style="text-align: center;"><small>Υπολειπόμενος χρόνος για {{timerMessage}} του διαγωνισμού:</small>&nbsp;<span class="badge badge-pill" v-bind:class="timerBadgeClass">{{timerValue}}</span></h5>
</template>

<script>
    export default {
        name: 'CountdownTimer',
        data: function () {
            return {timerValue: null};
        },
        props: {
            countDownDate: Date,
            timerMessage: {
                type: String
            }
        },
        created: function () {
            this.isRunning = false;
            this.timerBadgeClass = "badge-primary";
            this.countdown();
        },
        watch: {
            countDownDate: function () {
                if (!this.isRunning)
                    this.countdown();
            }
        },
        methods: {
            countdown: function () {
                let viewInst = this;
                this.isRunning = true;
                // Update the count down every 1 second
                let updateTimer = setInterval(function () {
                    // Get today's date and time
                    var now = new Date();

                    // Find the distance between now and the count down date
                    var timeDistance = viewInst.countDownDate.getTime() - now.getTime();

                    // Time calculations for days, hours, minutes and seconds
                    var days = Math.floor(timeDistance / (1000 * 60 * 60 * 24));
                    var hours = Math.floor((timeDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    var minutes = Math.floor((timeDistance % (1000 * 60 * 60)) / (1000 * 60));
                    var seconds = Math.floor((timeDistance % (1000 * 60)) / 1000);

                    // Display the result
                    viewInst.timerValue = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

                    // If the count down is finished, write some text
                    if (timeDistance < 0) {
                        clearInterval(updateTimer);
                        viewInst.isRunning = false;
                        viewInst.timerValue = "Έληξε!";
                        viewInst.timerBadgeClass = "badge-secondary";
                        viewInst.$emit('countdownEnd')
                    } else if (timeDistance <= 60 * 60 * 1000 ) {
                        viewInst.timerBadgeClass = "badge-danger";
                    }

                }, 1000);
            }
        }
    }
</script>

<style scoped>

</style>